import './manifest.json';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'initializer/initializeDatadog';
import 'initializer/msTeamsInitializer';
import 'initializer/initializeFullstory';
import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { ProvideFeatureFlags } from 'utils/flags/ProvideFeatureFlags';
import { globalQueryClient } from 'utils/globalQueryClient';
import { store } from './createStore';
import AppRoutes from './routes';
import { history } from './utils/history';

import 'sanitize.css/sanitize.css';
import './styles/global-fonts.css';
import './styles/global-misc.css';

declare global {
  interface Window {
    ENV?: 'dev' | 'staging' | 'production';
    TRIAL_INSTANCE?: boolean;
  }
}

ReactDOM.render(
  <ProvideFeatureFlags>
    <QueryClientProvider client={globalQueryClient}>
      <HelmetProvider>
        <Provider store={store}>
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <HistoryRouter history={history}>
            <AppRoutes />
          </HistoryRouter>
        </Provider>
      </HelmetProvider>
      {window.ENV === 'dev' && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      )}
    </QueryClientProvider>
  </ProvideFeatureFlags>,
  document.getElementById('app')
);
